import { RaffleDrawEntryAttributes } from "../attributes/raffle-draw-entry-attributes.ts";
import RaffleDrawParticipant from "./RaffleDrawParticipant";
import { RaffleDrawParticipantAttributes } from "../attributes/raffle-draw-participant-attributes";
import BaseModel from "./BaseModel";

class RaffleDrawEntry extends BaseModel {
  id: number;
  participant_status: number;
  participant?: RaffleDrawParticipant;
  created_at: Date | null;

  constructor(
    id: number,
    participant_status: number,
    participant?: RaffleDrawParticipant,
    created_at?: Date | null
  ) {
    super(created_at);
    this.id = id;
    this.participant_status = participant_status;
    this.participant = participant;
  }

  static fromJson(json: RaffleDrawEntryAttributes): RaffleDrawEntry | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new RaffleDrawEntry(
      json.id,
      json.participant_status
      //json.created_at,
      //RaffleDrawParticipant.fromJson(json.participant),
    );
  }
  static jsonToParticipant(
    json: Array<RaffleDrawParticipantAttributes>
  ): Array<RaffleDrawParticipant> {
    if (json === null || json === undefined) {
      return [];
    }

    return json.map((item) => RaffleDrawParticipant.fromJson(item));
  }
}

export default RaffleDrawEntry;
